const QUERIES = {
  USERS_LIST: "users-list",
  CAMPAIGN_REPORT_INFO: "campaign-report_info",
  CAMPAIGN_REPORT_DETAIL: "campaign-report_detail",
};

export { QUERIES };
